<app-navbar title="Home" />

<div class="py-8 px-4 space-y-4 overflow-y-auto max-h-[calc(100vh-5rem)] scrollbar-hide">
  <form class="w-full flex items-center justify-end" [formGroup]="periodFilter">
    <p-datepicker
      id="date_range"
      dateFormat="dd/mm/yy"
      formControlName="date_range"
      selectionMode="range"
      appendTo="body"
      size="small"
      fluid
      class="max-w-[184px] w-full"
    />
  </form>
  <div class="grid grid-cols-7 gap-4">
    <div class="col-span-7 relative">
      <app-dashboard-financial [startDateFilter]="startDate" [endDateFilter]="endDate" />
    </div>

    <div class="col-span-7 relative">
      <app-dashboard-operations [startDateFilter]="startDate" [endDateFilter]="endDate" />
    </div>

    <div class="col-span-7 relative">
      <app-dashboard-support-risk [startDateFilter]="startDate" [endDateFilter]="endDate" />
    </div>

    <!--  <div class="col-span-7 relative">
      <app-dashboard-marketing />
    </div>  -->

    <div class="col-span-7 relative">
      <app-dashboard-pending-deposits [startDateFilter]="startDate" [endDateFilter]="endDate" />
    </div>

    <div class="col-span-7 relative">
      <app-dashboard-deposit-avg-chart />
    </div>

    <div class="col-span-7 relative">
      <app-dashboard-ftd-avg-chart />
    </div>
  </div>
</div>
